import React from "react";
import PropTypes from "prop-types";
import config from "../config";

// ==============================|| LOADER ||============================== //
const SpinLoader = ({ message = "Loading...", compact = false, showMessage = false }) => (
  <div className={`app-spin-loader${compact ? " app-spin-loader--compact" : ""}`} role="status" aria-live="polite" aria-label={message}>
    <div className={`app-spin-loader__spinner${compact ? " app-spin-loader__spinner--compact" : ""}`}>
      <div className="app-spin-loader__ring" aria-hidden="true" />
      <div className="app-spin-loader__ring app-spin-loader__ring--secondary" aria-hidden="true" />
      <img src={config.logopath} alt="" className="app-spin-loader__logo" />
    </div>
    {showMessage ? <p className="app-spin-loader__message mb-0">{message}</p> : <span className="sr-only">{message}</span>}
  </div>
);

SpinLoader.propTypes = {
  message: PropTypes.string,
  compact: PropTypes.bool,
  showMessage: PropTypes.bool,
};

export default SpinLoader;
